import { defineStore } from 'pinia'
import { piniaPluginPersistedstate } from '#imports'

interface CustomerState {
  cartBackPath: string
}

export const useCartStore = defineStore('cart', {
  actions: {
    setCartBackPath(path: string) {
      this.cartBackPath = path
    },
  },
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
  },
  state: (): CustomerState => ({
    cartBackPath: '',
  }),
})
